import { Component, OnDestroy, OnInit } from '@angular/core';
import { SidebarService } from '../../services/sidebar.service';
import { CommonModule } from '@angular/common';
import { AppSidebarComponent } from '../app-sidebar/app-sidebar.component';
import { BackdropComponent } from '../backdrop/backdrop.component';
import { RouterModule } from '@angular/router';
import { AppHeaderComponent } from '../app-header/app-header.component';
import { NotificationContainerComponent } from "../../components/ui/notification/notification-container.component";
import { MenuService } from '../../../services/menu.service';
import { NavStateService } from '../../../services/nav-state.service';
import { SidebarItemResponse } from '../../../dto/sidebar-item.response';
import { InactivityService } from '../../../services/inactivity.service';
import { CompanyContextService } from '../../../services/company-context.service';

@Component({
  selector: 'app-layout',
  imports: [
    CommonModule,
    RouterModule,
    AppHeaderComponent,
    AppSidebarComponent,
    BackdropComponent,
    NotificationContainerComponent
],
  templateUrl: './app-layout.component.html',
})

export class AppLayoutComponent implements OnInit, OnDestroy {
  readonly isExpanded$;
  readonly isHovered$;
  readonly isMobileOpen$;

  constructor(
    public sidebarService: SidebarService,
    private menuService: MenuService,
    private navState: NavStateService,
    private inactivity: InactivityService,
    private companyContext: CompanyContextService,
  ) {
    this.isExpanded$ = this.sidebarService.isExpanded$;
    this.isHovered$ = this.sidebarService.isHovered$;
    this.isMobileOpen$ = this.sidebarService.isMobileOpen$;
  }

  ngOnInit(): void {
    this.inactivity.start();
    this.companyContext.load();
    this.menuService.getNavbar().subscribe({
      next: res => {
        const paths = this.extractPaths(res.data ?? []);
        this.navState.setNavbarPaths(paths);
      },
      error: () => {}
    });
  }

  ngOnDestroy(): void {
    this.inactivity.stop();
  }

  private extractPaths(items: SidebarItemResponse[]): string[] {
    const paths: string[] = [];
    for (const item of items) {
      if (item.path) paths.push(item.path);
      if (item.subItems) item.subItems.forEach(s => paths.push(s.path));
    }
    return paths;
  }

  get containerClasses() {
    return [
      'flex-1',
      'transition-all',
      'duration-300',
      'ease-in-out',
      (this.isExpanded$ || this.isHovered$) ? 'xl:ml-[290px]' : 'xl:ml-[90px]',
      this.isMobileOpen$ ? 'ml-0' : ''
    ];
  }

}
